/* eslint-disable */
import React, { useState, useEffect, useRef, Fragment } from "react";
import {
  Card,
  Layout,
  Row,
  Col,
  Button,
  Input,
  message,
  Modal,
  Space,
  Form,
  Table,
  Select, Badge,
  Divider
} from "antd";
import { Redirect } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { url } from "../../config/global";
import { BarcodeOutlined } from "@ant-design/icons";

const { Content } = Layout;

const layout = {
  labelCol: {
    xs: 24,
    lg: 24,
    md: 24,
  },
  wrapperCol: {
    xs: 24,
    lg: 24,
    md: 24,
  },
};

function SPTransformBeforePaint(props) {
  const [beforePaintList, setbeforePaintList] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setloading] = useState(false);
  const [pageSize, setPagesize] = useState(10);
  const [dataTable, setdataTable] = useState([]);
  const [disabledForm, setdisabledForm] = useState(true);
  const [disableKanban, setdisableKanban] = useState(true);
  const [disableRefDn, setdisableRefDn] = useState(false);
  const [afterItemList, setAfterItemList] = useState([]);
  const [listKanbanAfter, setlistKanbanAfter] = useState([]);
  const [data_kanban, setDataKanban] = useState([]);
  const [data_scanned, setDataScanned] = useState({});
  const [ref_outgoing, setRefOutgoing] = useState({});
  const [errorLotProd, setErrorLotProd] = useState(null);
  const [errorLotProdText, setErrorLotProdText] = useState(null);
  const [dnRefList, setDnRefList] = useState([]);
  const [failedData, setfailedData] = useState([]);
  const [oneTimeGet, setOneTimeGet] = useState(false);
  const [sort, setSort] = useState({
    sort: "item_code",
    order: "ascend",
  });
  const [data, setData] = useState({
    ref_dn: null,
    lot_prod: null,
    dn_outgoing: null,
    item_after: null,
    kanban_no: [],
    scan_outgoing_id: null,
    qty: 0,
  });

  const [descInput, setDescInput] = useState([]);
  const [afterItemInput, setafterItemInput] = useState(null);
  const [afterItemLabel, setAfterItemLabel] = useState(null);
  const [refDNInput, setrefDNInput] = useState(null);
  const [refDNInputID, setrefDNInputID] = useState(null);
  const [failedModal, setFailedModal] = useState(false);
  const [submitTime, setsubmitTime] = useState(null);

  const closeModal = () => {
    setFailedModal(false);
  };
  const resetForm = (resetDN = false) => {
    setafterItemInput(null)
    setdisabledForm(true)
    setdisableKanban(true)
    if(resetDN)
    {
      console.log('resetDN')
      setrefDNInput("")
      setrefDNInputID("")
    }
    setData({
      ...data,
      ref_dn: null,
      lot_prod: null,
      dn_outgoing: null,
      dn_no_outgoing: null,
      item_after: null,
      kanban_no: [],
      scan_outgoing_id: null,
      qty: 0,
    });

  }
  const resetAllConfirm = () => {
    Modal.confirm({
      title: "Konfirmasi",
      content: (
        <div>
          <p>Apakah anda yakin akan melakukan reset?</p>
        </div>
      ),
      okText: "Ya",
      showCancel: true,
      onCancel: () => {
        return;
      },
      cancelText: "Batal",
      confirmLoading: loading,
      onOk:  () => {
        resetAll();
      },
    });
  }
  const resetAll = () => {
    setDataScanned({});
    setdataTable([]);
    setafterItemInput(null)
    setdisabledForm(true)
    setdisableKanban(true)
    setdisableRefDn(false)
    setrefDNInput("")
    setAfterItemLabel(null)
    setafterItemInput(null)
    setrefDNInputID("")
    setOneTimeGet(false)
    setData({
      ...data,
      ref_dn: null,
      lot_prod: null,
      dn_outgoing: null,
      dn_no_outgoing: null,
      item_after: null,
      kanban_no: [],
      scan_outgoing_id: null,
      qty: 0,
    });

  }
  const submitData = () => {
    const filteredData = dataTable.filter(item => item.status);
    if(data.lot_prod == null)
    {
      setErrorLotProd('error');
      setErrorLotProdText('Mohon isi Lot Prod ');
      Modal.error({
        title: "Failed!",
        content: "Mohon isi Lot Prod ",
      });
      return 0;
    }
    // console.log(filteredData,filteredData.length,dataTable.length,'cekdata')
    // return;
    if (filteredData.length < dataTable.length) {
      Modal.error({
        title: "Failed!",
        content: "Mohon Scan semuanya dahulu ",
      });
      return 0;
    } else {
      Modal.confirm({
        title: "Konfirmasi",
        content: (
          <div>
            <p>Apakah anda yakin akan melakukan submit?</p>
          </div>
        ),
        okText: "Ya",
        showCancel: true,
        onCancel: () => {
          return;
        },
        cancelText: "Batal",
        confirmLoading: loading,
        onOk:  () => {
          saveTransform();
        },
      });
      
    }

  }
  const confirmAddKanban = () => {
    Modal.confirm({
          title: "Konfirmasi",
          content: (
            <div>
              <p>Apakah anda yakin kanban yang dipilih sesuai dengan aktual?</p>
            </div>
          ),
          okText: "Ya",
          showCancel: true,
          onCancel: () => {
            return;
          },
          cancelText: "Batal",
          confirmLoading: loading,
          onOk:  () => {
            addKanban();
          },
        });
  }
  const addKanban = () => {
    const pubData = data;
    const cekData = dataTable.find((x) => x.item_before === afterItemInput);
    // console.log(cekData,'ckdata')
    if (data.kanban_no.length == 0) {
      Modal.error({
        title: "Failed!",
        content: "Mohon pilih dulu kanban ",
      });
      return 0;
    }
    if (cekData == undefined) {
      Modal.error({
        title: "Failed!",
        content: "Item yang dipilih tidak ada pada daftar transformasi",
      });
      return 0;
    }
    const tscanned = pubData.qty + cekData.qty_actual;
    if(tscanned >  cekData.qty)
    {
      Modal.error({
        title: "Failed!",
        content: "Item ini sudah terpenuhi",
      });
      return false;

    }
    if (tscanned == cekData.qty) {
      // [...(data_scanned[afterItemInput] || []),data.kanban_no]
    setRefOutgoing((prev) => ({
      ...prev,
      [`${afterItemInput}`]: [
        ...(prev[afterItemInput] || []),
        ...(prev[afterItemInput]?.includes(refDNInput) ? [] : [refDNInput]),
      ],
    }));


      var updateData = dataTable.map((data) =>
        data.item_before === afterItemInput ? { ...data, status: true, ref_dn_outgoing: ref_outgoing[afterItemInput], qty_actual: pubData.qty + data.qty_actual } : data
      );
      var updateItemAfter = afterItemList.filter((item) => item.value != afterItemInput);
      setAfterItemList(updateItemAfter)
      // setdataTable(updateData);
    } else {
      setRefOutgoing((prev) => ({
        ...prev,
        [`${afterItemInput}`]: [
          ...(prev[afterItemInput] || []),
          ...(prev[afterItemInput]?.includes(refDNInput) ? [] : [refDNInput]),
        ],
      }));
      // console.log('test',test)
      var updateData = dataTable.map((data) =>
        data.item_before === afterItemInput ? { ...data, ref_dn_outgoing: ref_outgoing[afterItemInput], qty_actual: pubData.qty + data.qty_actual } : data
      );
    }
    setdataTable(updateData);
    // console.log(ref_outgoing, 'nab')
    const item = [`${afterItemInput}`];

    setDataScanned((prev) => ({
      ...prev,
      [`${afterItemInput}`]: [...(prev[afterItemInput] || []), data.kanban_no],
    }));

    // console.log(updateData,'update',data.kanban_no);


    setafterItemInput(null)
    setAfterItemLabel(null)
    setdisableKanban(true)
    // setrefDNInput(null)
    setData({
      ...data,
      // lot_prod: null,
      item_after: null,
      kanban_no: [],
      qty: 0,
    });
    message.success("Data Berhasil ditambahkan");
    // Modal.success({
    //   title: "Success!",
    //   content: "Data Berhasil ditambahkan",
    // });


  }
  const handleMultipleSelect = (name, value) => {
   console.log(value)
    if (name == 'item_after') {
      setData({
        ...data,
        item_after: value.value,
      });
      setafterItemInput(value.value);
      setAfterItemLabel(value.label);
      // console.log(value.value);
      // console.log(value.value)
      getListKanban(value.value)
    }
    else if (name == 'ref_dn') {
     
      if(value == undefined)
        {
          
          setrefDNInput("")
          setrefDNInputID("")
          setData({
            ...data,
            ref_dn: '',
            kanban_no: [],
            dn_no_outgoing:null,
            qty: 0
          });
          return false
        }
        resetForm(false)
      setData({
        ...data,
        ref_dn: value.value,
        kanban_no: [],
        qty: 0
      });
      setrefDNInput(value.label);
      setrefDNInputID(value.value);
      // console.log(value)
      getRefDN(value.value)
    }
    else if (name == 'kanban_no') {
      const cekKanban = data_kanban.filter(
        (x) => value.includes(x.barcode)
      );
      // const cekKanban = data_kanban.find(
      //   (x) => value.some((val) => x.barcode === val)
      // );
      // console.log("kanban", value, cekKanban, data_kanban)
      var resCalc = 0;
      cekKanban.forEach((res, index) => {
        resCalc += res.qty_kanban

      })
      // console.log(resCalc)
      setData({
        ...data,
        qty: resCalc,
        kanban_no: value
      })


    } else {
      setData({
        ...data,
        [`${name}`]: value,
      });
    }

  }

  const handleGetRef = (e) => {
    if (e.key === 'Enter') {
      var refDN = e.target.value
      getRefDN(refDN)
    }

  }
  const getListKanban = (item_number) => {
    setloading(true);
    setdisableKanban(true)
    setData({
      ...data,
      kanban_no: [],
      qty: 0
    });
    if (Object.keys(data_scanned).length > 0) {
      var encoded = JSON.stringify(data_scanned)
    } else {
      var encoded = null
    }
    // console.log('scanned',)

    Axios.post(
      `${url}/transformation-item/list-kanban`,
      {
        ex: encoded,
        item_number: item_number,
        scan_outgoing_id: data.scan_outgoing_id,
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    )
    .then((res) => {
      setlistKanbanAfter(res.data.data);
      setDataKanban(res.data.data_kanban);
      setdisableKanban(false);
    })
    .catch((err) => {
      if (err.response) {
        setData({
          ...data,
          kanban_number: "",
        });
    
        Modal.error({
          title: "Failed!",
          content: err.response.data.message,
        });
    
        if (err.response.status === 401) {
          sessionStorage.removeItem("token");
        }
      }
    })
    .finally(() => {
      setloading(false);
    });
  };
  const getListRefDn = () => {
    setloading(true);
    setdisableKanban(true)
    setData({
      ...data,
      kanban_no: [],
      qty: 0
    });
    Axios.get(`${url}/transformation-item/list-dn`, {

      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }).then((res) => {
      const option = res.data.data.map((data) => ({
        label: data.ref_dn_number,
        value: data._id
      }))
      setDnRefList(option)
    }).catch((err) => {
      if (err.response) {
        setData({
          ...data,
          kanban_number: "",
        });
        Modal.error({
          title: "Failed!",
          content: err.response.data.message,
        });

        if (err.response.status == 401) {
          sessionStorage.removeItem("token");
        }
      }
    }).finally((res) => {
      setloading(false)
    });
  };
  const getRefDN = (refDN) => {
    setloading(true);
    setdisableRefDn(true)
    Axios.get(`${url}/transformation-item/check-ref-dn`, {
      params: {
        ref_dn: refDN,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }).then((res) => {
      setData({
        ...data,
        ref_dn: refDN,
      });
      // console.log(res.data.data_dn)
      const option = res.data.data_dn.map((data) => ({
        label: data.item_before_number+' - '+data.item_before,
        value: data.item_before
      }))

      // console.log(option);
      setAfterItemList(option)
      setdisabledForm(false)
     
      setOneTimeGet(true)
      if (!oneTimeGet) {
     
        setData({
          ...data,
          scan_outgoing_id: res.data.data._id,
          ref_dn: res.data.data.number,
          supplier_id: res.data.data.supplier_id,
          supplier_name: res.data.data.supplier_name,
          dn_no_outgoing: res.data.data.dn_no,
          primary_ref_dn: res.data.data._id
        });
        setdataTable(res.data.data_dn)
        
      } else{
        setData({
          ...data,
          scan_outgoing_id: res.data.data._id,
          ref_dn: res.data.data.number,
          supplier_id: res.data.data.supplier_id,
          supplier_name: res.data.data.supplier_name,
        });

      }
      
    }).catch((err) => {
      setdisableRefDn(false)
      if (err.response) {
        // console.log(err.response)
       
        Modal.error({
          title: "Failed!",
          content: err.response.data.message,
        });

        if (err.response.status == 401) {
          sessionStorage.removeItem("token");
        }
      }
    }).finally((res) => {
      setloading(false)
    });
  };




  useEffect(() => {
    getListRefDn()

  }, []);

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  const columns = [

    {
      title: "Status",
      render: (data) => {
        var calc = data.qty_actual
        if (calc == data.qty && data.status == true) {
          return (<div><Badge
            count={"Scanned"} style={{ backgroundColor: '#52c41a' }} /> </div>)
        } else if ((calc > 0 && calc <= data.qty) && data.status == false) {
          return (<div><Badge
            count={"Not Completed"} style={{ color: '#000', backgroundColor: '#ffc53d' }} /> </div>)
        }
        else {
          return (<div><Badge
            count={"Not Scanned"} style={{ backgroundColor: '#f5222d' }} /> </div>)
        }
      }
    },
    {
      title: "Qty",
      dataIndex: "qty",
      sorter: true,
    },
    {
      title: "Qty Actual",
      dataIndex: "qty_actual",
      sorter: true,
    },
    {
      title: "Item Before",
      dataIndex: "item_before",
      sorter: true,
    },
    {
      title: "Item Before Number",
      dataIndex: "item_before_number",
      sorter: true,
    },
    {
      title: "Item After",
      dataIndex: "item_after",
      sorter: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: true,
    },

    {
      title: "Ref DN Outgoing",
      // dataIndex: "ref_dn_outgoing",
      render: (data) => {
        // console.log('data', data, ref_outgoing[data.item_after], data_scanned)
        if (ref_outgoing[data.item_before] != undefined) {
          return (<div>{ref_outgoing[data.item_before].map((item, index) => (
            <span key={'refdn-' + index}>{item}<br /></span>
          ))}</div>)
        } else {
          return "-"
        }
      }
    },

    {
      title: "Unit",
      dataIndex: "unit",
      sorter: true,
    },
  ];

  const saveTransform = () => {
    setloading(true);
    Axios.post(
      `${url}/transformation-item/store-history`,
      {
        data_transform: dataTable,
        data_scanned: data_scanned,
        // data_kanban: data_kanban,
        data:data,
        ref_outgoing
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    )
      .then((res) => {
        setloading(false);
        Modal.success({
          title: "Success!",
          content: res.data.message,
        });
        resetAll();
      })
      .catch((err) => {
        // console.log(err.response.data);
            if (err.response) {
              if(err.response.data.err_data)
                {
                  setfailedData(err.response.data.err_data)
                  setFailedModal(true)
                  setsubmitTime(err.response.data.submit_time)
                }
              Modal.error({
                title: "Failed!",
                content: err.response.data.message,
              });
              // message.error(err.response.data.message);
              if (err.response.status === 422) {
                setError(err.response.data.errors);
              }
              if (err.response.status === 401) {
                sessionStorage.removeItem("token");
              }
            }
            setloading(false);
      }
      );

  }

  const columnsFailed = [
  
    {
      title: "Item Number",
      dataIndex: "item_number",
     
    },
   
    {
      title: "Description",
      dataIndex: "description",
    
    },
    {
      title: "Qty Order",
      dataIndex: "qty",
    
    },
    {
      title: "Qty Actual",
      dataIndex: "qty_actual",
    
    },
  ];
  return (
    <Fragment>
       <Modal
              title="PO Tidak Ditemukan "
              visible={failedModal}
              width={1200}
              footer={null}
              onCancel={closeModal}
            >
              <Card className="body-data">
                { submitTime != null && (<small>Waktu Submit: {submitTime}</small>)}
                <div name="control-hooks">
                  <Table
                  
                    columns={columnsFailed}
                    dataSource={failedData}
                    rowKey={(data) => data.id}
                    // onChange={handleTableChange}
                    loading={loading}
                  />
                  <div>
                    <Button onClick={closeModal}>
                      Tutup
                    </Button>
                  </div>
                </div>
              </Card>
            </Modal>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="Transform Item"
            bodyStyle={{ padding: "0" }}
            extra={moment(new Date()).format("DD MMMM YYYY")}
          ></Card>
        </Col>
      </Row>

      <Content className="content">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Form {...layout} layout="vertical" >
                <Row>
                  <Col xs={24} md={24} lg={24}>
                    <Form.Item label="Ref DN : *">
                      {/* <Input
                        disabled={!disabledForm}
                        placeholder="cth : SN2504090001 atau XXXX/WH-SDI/LXXXX/VII/2025"
                        type="primary"
                        onKeyDown={(e) => handleGetRef(e)}
                        value={data.ref_dn}
                        onChange={(e) => setData({ ...data, ref_dn: e.target.value })}
                        

                      /> */}
                      <Select
                        // mode="multiple"
                        // disabled={disabledForm}
                        allowClear
                        labelInValue
                        disabled={disableRefDn}
                        console={console.log(disableRefDn,'DN D')}
                        style={{ width: '100%' }}
                        placeholder="Pilih Ref DN"
                        onClick={() => getListRefDn()}
                        showSearch
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onChange={(e) => handleMultipleSelect("ref_dn", e)}
                        cs={console.log(refDNInputID,'af')}
                        value={refDNInputID != '' ?{
                          key: refDNInputID,
                          label: refDNInput
                        }:{
                          key: '',
                          label: ''
                        }}
                        options={dnRefList}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={24} lg={24}>
                    <Form.Item label="Lot Prod: *" validateStatus={errorLotProd} hasFeedback help={errorLotProdText}>
                      <Input

                        disabled={disabledForm}
                        type="primary"
                        placeholder="Masukan lot produksi anda"
                        value={data.lot_prod}
                        onChange={(e) => {setData({ ...data, lot_prod: e.target.value }); setErrorLotProd(null);
                        setErrorLotProdText(null);}}


                      />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} md={24} lg={24}>
                    <Form.Item label="DN Outgoing:">
                      <Input

                        readOnly={true}
                        type="primary"
                        value={data.dn_no_outgoing}


                      />
                    </Form.Item>
                  </Col> */}
                  <Col xs={24} md={24} lg={24}>
                    <Form.Item label="Item Before:">
                      <Select
                        // mode="multiple"
                        disabled={disabledForm}
                        allowClear
                        labelInValue
                        style={{ width: '100%' }}
                        placeholder="Pilih Item Before"
                        onChange={(e) => handleMultipleSelect("item_after", e)}
                        // cs={console.log(afterItemInput, 'af')}
                        value={{
                          key: afterItemInput,
                          label: afterItemLabel
                        }}
                        options={afterItemList}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={12}>
                    <Form.Item label="Kanban No:">
                      <Select
                        mode="multiple"
                        disabled={disabledForm || disableKanban}
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Pilih Kanban"
                        onChange={(e) => handleMultipleSelect("kanban_no", e)}
                        value={data.kanban_no}
                        options={listKanbanAfter}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={12}>
                    <Form.Item style={{ paddingLeft: '10px' }} label="Qty:">
                      <Input

                        readOnly={true}
                        type="primary"
                        value={data.qty}


                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={24} lg={24}>
                    <Button
                      type="primary"
                      onClick={() => confirmAddKanban()}
                      loading={loading}
                      // disabled={data.nomor_kendaraan === "" ? true : false}
                      className="mr-button"
                    >
                      Add
                    </Button>

                    {/* <Button
                      onClick={(e) => resetForm(true)}
                      type="danger"
                      // disabled={disabledDN}
                      htmlType="button"
                      className="mr-button"
                    >
                      Reset
                    </Button> */}
                  </Col>

                </Row>
                <Divider />
                <Row>
                  <Col xs={24} md={24} lg={24}>
                    <Table
                      scroll={{ x: 1100 }}
                      columns={columns}
                      dataSource={dataTable}
                      // rowKey={(data) => data._id}
                      // onChange={handleTableChange}
                      // pagination={{
                      //   pageSize: pageSize,
                      //   total: data.total,
                      //   showSizeChanger: true,
                      // }}
                      loading={loading}
                    />
                  </Col>

                  <Col xs={24} md={24} lg={24}>
                    <Divider />
                    <Button
                      type="primary"
                      onClick={() => submitData()}
                      // on={submitData}
                      loading={loading}
                      disabled={dataTable.length == 0 ? true : false}
                      className="mr-button"
                    >
                      Submit
                    </Button>

                    <Button
                      onClick={() => resetAllConfirm()}
                      type="danger"
                      disabled={dataTable.length == 0 ? true : false}
                      htmlType="button"
                      className="mr-button"
                    >
                      Reset
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
}

export default SPTransformBeforePaint;
